import React from 'react';
import classNames from 'classnames';
import DynamicIcon from './DynamicIcon';
import './button.scss';

const Button = ({
    id,
    forwardRef,
    className = '',
    type = 'button',
    iconSize = 22,
    iconWeight = 'fill',
    loading,
    disabled,
    color,
    onClick,
    style,
    icon,
    text,
    iconAtTheEnd,
    textSize = 16,
}) => {
    const classNameButton = classNames('Button', `Button-${color}`, className, {
        'Button-disabled': disabled,
    });

    const classNameIcon = classNames('f ai-c', {
        'mr-8': text && !iconAtTheEnd,
        'ml-8': text && iconAtTheEnd,
    });

    return (
        <button
            id={id}
            ref={forwardRef}
            type={type}
            onClick={onClick}
            disabled={disabled}
            style={style}
            className={classNameButton}
        >
            <>
                {iconAtTheEnd && <div className="fs-16">{text}</div>}
                {!!icon && (
                    <div className={classNameIcon}>
                        <DynamicIcon
                            iconName={loading ? 'CircleNotch' : icon}
                            size={iconSize}
                            weight={iconWeight}
                            className={loading ? 'processing' : ''}
                        />
                    </div>
                )}
                {!iconAtTheEnd && <div className={`fs-${textSize}`}>{text}</div>}
            </>
        </button>
    );
};

const ButtonWithRef = React.forwardRef((props, ref) => <Button {...props} forwardRef={ref} />);
ButtonWithRef.displayName = 'Button';

export default Button;
